import React, { useState, useEffect } from 'react'
import axios from "axios";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { fetchpricingmodal, pricingSelector } from '../api/pricesetting';

const FullcarsCard = () => {
  const { currentPricing } = useSelector(pricingSelector)
  const dispatch = useDispatch();
  const [sortConfig, setSortConfig] = useState({ key: null, ascending: true });
  const [selectedCategory, setSelectedCategory] = useState("");
  const location = useLocation();
  const navigate = useNavigate();

  const [cars, setCars] = useState([]);
  const [pricing_obj, setPricing_obj] = useState({});

  useEffect(() => {
    dispatch(fetchpricingmodal())
  }, [dispatch]);

  useEffect(() => {
    setPricing_obj((currentPricing?.[0]));
  }, [currentPricing]);

  useEffect(() => {
    const fetchCars = async () => {
      try {
        const response = await axios.get("http://localhost:5000/api/get-all-vehicles");
        setCars(response.data);
      } catch (error) {
        console.error("Error fetching car data:", error);
      }
    };
    fetchCars();
  }, []);

  const handleCarClick = (car) => {
    if (car && car.brand_name && car.model_name) {
      navigate('/fullcabbooking', {
        state: { cars: [car] }
      });
    } else {
      console.error("Car data is invalid.");
    }
  };

  const handleSortFare = () => {
    setSortConfig((prev) => ({
      key: "price",
      ascending: prev.key === "price" ? !prev.ascending : true,
    }));
  };

  const handleCategoryChange = (e) => {
    setSelectedCategory(e.target.value);
  };

  const getpricing = (car) => {
    if (!car || !pricing_obj) return 0;
    
    if (pricing_obj?.pricing_model === 'Driver Fixed') {
      if (car?.price_per_trip?.$numberDecimal) {
        const Per_Seat_Price = Number(car.price_per_trip.$numberDecimal);
        return Per_Seat_Price + (Per_Seat_Price * ((pricing_obj?.platform_price)/100));
      }
    } else if (pricing_obj?.pricing_model === 'Admin Fixed') {
      if (pricing_obj?.full_cab_price_per_day?.$numberDecimal) {
        return Number(pricing_obj.full_cab_price_per_day.$numberDecimal);
      }
    }
    return 0;
  };

  // Filter cars by category first
  const filteredCars = selectedCategory
    ? cars.filter((car) => car.category === selectedCategory)
    : cars;

  // Then sort the filtered cars
  const sortedCars = [...filteredCars].sort((a, b) => {
    if (sortConfig.key === "price") {
      const priceA = getpricing(a);
      const priceB = getpricing(b);
      return sortConfig.ascending ? priceA - priceB : priceB - priceA;
    }
    return 0;
  });

  const uniqueCategories = [...new Set(cars.map((car) => car.category))];

  return (
    <div className="flex flex-col lg:w-3/4 mx-auto p-4 pt-5 md:pt-40 font-lato">
      <div className="w-full">
        <div className="flex flex-wrap justify-center gap-4 mb-6">
          <button
            onClick={() => navigate(-1)}
            className="px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-medium transition-all duration-300 shadow-md text-sm sm:text-base bg-gray-300 text-gray-700 hover:bg-gradient-to-r hover:from-gray-400 hover:to-gray-500 hover:text-white"
          >
            Go Back
          </button>
          {[
            { path: "/fullcars", label: "Full Cars" },
          ].map((tab) => (
            <Link key={tab.path} to={tab.path}>
              <button
                className={`px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-medium transition-all duration-300 shadow-md text-sm sm:text-base ${location.pathname === tab.path
                  ? "bg-gradient-to-r from-indigo-500 to-purple-600 text-white shadow-lg transform scale-105"
                  : "bg-gray-300 text-gray-700 hover:bg-gradient-to-r hover:from-gray-400 hover:to-gray-500 hover:text-white"
                  }`}
              >
                {tab.label}
              </button>
            </Link>
          ))}
        </div>

        <div className="flex justify-between bg-gray-100 p-1 shadow-md rounded-lg text-gray-800 font-semibold text-sm sm:text-base">
          <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4 w-full">
            <select
              className="w-full sm:w-auto p-2 border rounded-md focus:outline-none focus:ring focus:ring-indigo-300"
              value={selectedCategory}
              onChange={handleCategoryChange}
            >
              <option value="">All Categories</option>
              {uniqueCategories.map((category, idx) => (
                <option key={idx} value={category}>
                  {category}
                </option>
              ))}
            </select>

            <button
              className="w-full sm:w-auto min-w-[150px] px-4 py-2 bg-indigo-500 text-white rounded-md hover:bg-indigo-600 transition-all"
              onClick={handleSortFare}
            >
              Sort by Fare {sortConfig.ascending ? "▲" : "▼"}
            </button>
          </div>
        </div>

        {sortedCars.map((car, index) => (
          <div
            key={index}
            className="bg-white bg-opacity-90 backdrop-blur-md rounded-lg shadow-lg p-5 my-4 flex flex-col sm:flex-row gap-6 border border-gray-200 hover:shadow-xl transition-all"
          >
            <img
              src={car.picture_of_the_vehicle || "/placeholder.svg"}
             alt={car.brand_name + ' ' + car.model_name}

              className="w-full sm:w-1/3 object-cover rounded-lg shadow-md"
            />

            <div className="flex flex-col sm:flex-row justify-between w-full">
              <div className="flex-grow">
                <h3 className="text-xl font-bold text-gray-800">{car.brand_name} {car.model_name}</h3>
                <p className="text-gray-600 text-sm sm:text-base">{car.capacity} Seater</p>
                <ul className="text-gray-500 text-sm mt-2">
                  {Array.isArray(car.features) && car.features.length > 0 ? (
                    car.features.map((feature, idx) => (
                      <li key={idx}>• {feature}</li>
                    ))
                  ) : (
                    <>
                      <li>• Air Conditioned Luxury SUV</li>
                      <li>• Comfortable & Spacious Seating</li>
                      <li>• Female Passenger Safety Standards</li>
                      <li>• Comfortable & Spacious Seating</li>
                    </>
                  )}
                </ul>
              </div>

              <div className="flex flex-col items-end justify-between text-right">
                <p className="bg-green-300 text-green-800 px-3 py-1 mt-3 rounded-full font-semibold text-sm">{car.category}</p>
                <p className="text-gray-400 line-through text-xl">₹{(getpricing(car) + 1000)}</p>
                <p className="text-2xl font-bold text-blue-600">₹{getpricing(car)}/Day</p>

                <button 
                  onClick={() => handleCarClick(car)} 
                  className="mt-4 bg-gradient-to-r from-blue-400 to-blue-600 text-white py-2 px-5 rounded-md shadow-lg hover:from-blue-500 hover:to-blue-700 transition-all"
                >
                  Book Now
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FullcarsCard;